import { z } from 'zod'

const appConfigSchema = z.object({
  userPoolId: z.string(),
  userPoolClientId: z.string(),
  cognitoDomain: z.string(),
  apiUrl: z.string().url(),
  region: z.string(),
})
export type AppConfig = z.infer<typeof appConfigSchema>

let cached: AppConfig | undefined

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached
  const res = await fetch('/config.json', { cache: 'no-store' })
  if (!res.ok) throw new Error(`Failed to load /config.json: ${res.status}`)
  cached = appConfigSchema.parse(await res.json())
  return cached
}
